import React, { useState } from "react";
import { connect } from "react-redux";
import { formatPrice } from "../../../../services/helpers/Helper";
import { commentPosts } from "../../../../store/action/campaignsAction";
import Popover from "../../../shared/components/popover";
import FormManual from "./form-manual";
import FormProductList from "./form-product-list";
import ItemProduct from "./item-product";


const FormEdit = (props) => {
   const { campaign, commentPosts, settingPage } = props;
   const { type_comment } = settingPage
   const { products, posts } = campaign;
   const [show, setShow] = useState(false);
   const [x, setX] = useState(0);
   const [y, setY] = useState(0);
   const [isShowModalStore, setIsShowModalStore] = useState(false);
   const [isShowModalManual, setIsShowModalManual] = useState(false);
   const [itemSelectProductWarehouse, setItemSelectProductWarehouse] = useState([]);

   const handleSetXY = (e) => {
      setX(e.clientX);
      setY(e.clientY);
   }

   const handleShow = (e) => {
      handleSetXY(e);
      setShow(true);
   }

   const onClose = () => {
      setShow(false);
   }

   const handleSelectedProductWarehouse = (data) => {
      setItemSelectProductWarehouse(data);
      setIsShowModalManual(true);
      setIsShowModalStore(false);
   }

   const handlePostComment = () => {
      let comment_message = `⚡️⚡️Sản phẩm đang bán ⚡️⚡
      ${products.map((item) => {
         return `${item.product_name} ${formatPrice(item.product_selling_price)} ₫ | Cú pháp: ${item?.keywords?.map(m => m.keyword).join(" ")}`
      }).join('\n')}
      ${type_comment == 2 ?
            '[Cú pháp chốt đơn] Bình luận có chứa Mã sản phẩm'
            :
            '[Cú pháp chốt đơn] Bình luận có chứa Mã sản phẩm, Mã biến thể (nếu có) và Số điện thoại'}`;
      const data = posts.map((m) => {
         return {
            "fb_page_id": m.fb_page_id,
            "fb_post_id": m.post_id,
            "comment_message": comment_message
         }
      })
      commentPosts(data);
   }

   return (
      <div className="display-flex gap-20 ps-relative" id="sale-post-product-list-wrapper-id" >
         <div className="card-sale-post sale-post-product-list">
            <div className="d-flex align-items-center">
               <div className="title">
                  <div className="svg-next-icon mb2 icon-tshirt-product">
                  </div>
                  <div className="d-flex">
                     <span>Sản phẩm</span>
                     <span className="font-size-12 quantity text-no-bold">({products.length})</span>
                  </div>
               </div>
               {products.length > 0 &&
                  <div className="display-flex action">
                     <div className="flex-1 flex-display-flex-end ml8 ps-relative">
                        <div className="item pointer animation-search"><div className="svg-next-icon ic-search-3"></div></div>
                     </div>
                     <div>
                        <div className="item pointer">
                           <span><div className="svg-next-icon reload-outline"></div></span>
                        </div>
                     </div>
                     <div>
                        <button type="button" className="app-btn app-btn-primary button-add" onClick={handleShow}>
                           <span>Thêm</span>
                           <div className="svg-next-icon ic-arrow-down-2">
                           </div>
                        </button>
                     </div>
                  </div>
               }
            </div>
            <div className="body">
               <div className="virtual-scroll-container live-stream-list-product scrollbar-narrow" style={{ height: 464, overflow: "auto" }}>
                  {products.length > 0 ?
                     <React.Fragment>
                        {products.map((item, index) => {
                           return (<ItemProduct product={item} key={index} />)
                        })}
                     </React.Fragment>
                     :
                     <div className="empty">
                        <div className="svg-next-icon shopping">
                        </div>
                        <div className="mt16">
                           <span>
                              Thêm sản phẩm vào danh sách bán hàng
                           </span>
                        </div>
                        <div className="mt16">
                           <div>
                              <button type="button" className="app-btn app-btn-primary button-add" onClick={handleShow}>
                                 <span>Thêm</span>
                                 <div className="svg-next-icon ic-arrow-down-2">
                                 </div>
                              </button>
                           </div>
                        </div>
                     </div>}
               </div>
            </div>
         </div>
         <div className="sale-post-suggestion">
            <h3>
               <div className="svg-next-icon warning-hop">
               </div>
               Gợi ý nội dung bài viết và bình luận
            </h3>
            {products.length > 0 ?
               <React.Fragment>
                  <div className="box-desc">
                     <div className="mb10">Bạn hãy thực hiện theo các bước sau:</div>
                     <ol>
                        <li>Truy cập vào bài viết cần áp dụng bán hàng tự động.</li>
                        <li>Kích hoạt kịch bản</li>
                        <li>Bấm vào nút <b>Đăng bình luận</b> bên dưới để tự động đăng bình luận hướng dẫn đặt hàng trong bài viết .</li>
                     </ol>
                     <div>
                        Mẹo: Nếu bài viết có nhiều hình, bạn nên sửa lại nội dung cho phù hợp với từng sản phẩm trong hình để tăng tỷ lệ
                        chốt đơn thành công.
                     </div>
                  </div>
                  <div className="box-content">
                     <div className="content-suggestion-wrapper scrollbar-narrow">
                        <span>⚡️⚡️Sản phẩm đang bán ⚡️⚡
                           <ul>
                              {products.map((item, index) => {
                                 return (<li key={index}>{item.product_name} {formatPrice(item.product_selling_price)} ₫ | Cú pháp: {item?.keywords?.map(m => m.keyword).join(" ")}</li>);
                              })}
                              {type_comment == 2 ?
                                 <li>[Cú pháp chốt đơn] Bình luận có chứa Mã sản phẩm</li>
                                 :
                                 <li>[Cú pháp chốt đơn] Bình luận có chứa Mã sản phẩm, Mã biến thể (nếu có) và Số điện thoại</li>
                              }
                           </ul>
                        </span>
                     </div>
                     <div className="ps-relative"><span className="mr8" style={{ display: 'inline-block', cursor: 'not-allowed' }}>
                        <button disabled={!campaign.is_active} type="button" className="app-btn app-btn-primary" onClick={handlePostComment}>
                           Đăng bình luận
                           <div className="svg-next-icon ml8 ic-send-msg">
                           </div>
                        </button>
                     </span>
                        <div style={{ position: 'absolute', top: 0, left: 0, width: '100%' }}>
                           <div>
                              <div className="app-tooltip tooltip-btn-post-comment app-tooltip-placement-bottom  app-tooltip-hidden"
                                 style={{ left: -8, top: 44, transformOrigin: '50% - 4px' }}>
                                 <div className="app-tooltip-content">
                                    <div className="app-tooltip-arrow"></div>
                                    <div className="app-tooltip-inner" role="tooltip">Vui lòng kích hoạt kịch bản để đăng bình luận.</div>
                                 </div>
                              </div>
                           </div>
                        </div>
                     </div>
                  </div>
               </React.Fragment>
               :
               <span className="box-desc empty">
                  Bạn hãy chọn sản phẩm và bài viết tương ứng để Viettelsocial gợi ý nội dung hướng dẫn khách mua hàng nhanh chóng và hiệu quả hơn.
               </span>
            }
            <div className="instruction-link flex-1 color-blue">
               <a href="" target="_blank">
                  Xem hướng dẫn chi tiết
               </a>
            </div>
         </div>
         <Popover isOpen={show} onClose={onClose}>
            <div className="app-popover app-popover-hidden-arrow app-popover-placement-bottom ps-fixed" style={{ top: y, left: x }}>
               <div className="app-popover-content">
                  <div className="app-popover-arrow"></div>
                  <div className="app-popover-inner" role="tooltip">
                     <div>
                        <div className="app-popover-inner-content">
                           <div className="border-radius4 over-hide pointer">
                              <div className="popover-add-product" onClick={() => { setIsShowModalStore(true); onClose(); }}>
                                 <div className="svg-next-icon icon-tshirt-product">
                                 </div>
                                 <span className="ml8 inline-block mt3">
                                    Chọn sản phẩm từ Viettelsocial
                                 </span>
                              </div>
                              <div className="popover-add-product" onClick={() => { setIsShowModalManual(true); onClose(); }}>
                                 <div className="svg-next-icon ic-edit-text">
                                 </div>
                                 <span className="ml8 inline-block mt3">
                                    Nhập thủ công
                                 </span>
                              </div>
                              {/* <div className="popover-add-product">
                                 <div className="svg-next-icon ic-upload-arrow">
                                 </div>
                                 <span className="ml8 inline-block mt3">
                                    Tải lên danh sách
                                 </span>
                              </div> */}
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </Popover>
         {isShowModalStore && <FormProductList
            onClose={() => setIsShowModalStore(false)}
            handleSelectedProductWarehouse={handleSelectedProductWarehouse}
         />}
         {isShowModalManual && <FormManual
            onClose={() => {
               setIsShowModalManual(false);
               setItemSelectProductWarehouse([]);
            }}
            itemSelectProductWarehouse={itemSelectProductWarehouse}
         />}
      </div>
   )
}

const mapStateToProps = (state) => {
   const { campaign, page, settingPage } = state;
   return {
      campaign,
      page,
      settingPage
   };
};


export default connect(mapStateToProps, {
   commentPosts
})(FormEdit)
